import { hexColor, Show, Text, View } from "@lightningtv/solid";
import { createSignal } from "solid-js";
import { fontFamily, isRTL, t } from "../../translations/configuration";

export function AddPlaylistManuallyButton(props: any) {
    const [focused, setFocused] = createSignal(false);
    return (
        <View
            ref={props.onRef}
            x={props.x} y={props.y}
            width={380} height={65}
            borderRadius={14}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
            onEnter={props.onEnter}
            onUp={props.onUp}
            onDown={props.onDown}
            onRight={props.onRight}
        >
            <Show when={focused()}>
                <View
                    x={-2} y={-2}
                    width={384} height={69}
                    borderRadius={14}
                    color={hexColor("#2563eb")}
                    zIndex={-1}
                />
            </Show>
            <View x={0} y={0} width={380} height={65} borderRadius={14} color={hexColor("#2d3748")}>
                <View
                    x={2} y={2}
                    width={376} height={61}
                    borderRadius={14}
                    color={hexColor("#0d1117")}
                >
                    <View x={18} y={20} width={22} height={22} src="https://i.ibb.co/Wv8k0GR/list-1.png" color={hexColor("#8b949e")} />
                    <Text x={70} y={22} fontSize={20} fontWeight={isRTL() ? "normal" : "bold"} style={{ fontFamily: fontFamily(), color: hexColor("#ffffff") }}>
                        {t("add_playlist")}
                    </Text>
                </View>
            </View>
        </View>
    );
}
